export default __webpack_public_path__ + "c5cf0b671643d8466a397bc36d408330.mov";